import { render, staticRenderFns } from "./index.vue?vue&type=template&id=b163e662&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b163e662",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\www\\mer\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b163e662')) {
      api.createRecord('b163e662', component.options)
    } else {
      api.reload('b163e662', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=b163e662&scoped=true", function () {
      api.rerender('b163e662', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/distribution/setting/withdrawConfig/index.vue"
export default component.exports